import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/admin/manage-products/")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/admin/manage-products/categories",
    })
  },
})
